import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".DateInput-module_popover__26Zs5 {\n  position: relative;\n  min-width: 324px;\n  border: 1px solid #b1b5b9;\n  border-radius: 5px;\n  color: #090a0b;\n  background-color: #ffffff;\n  box-shadow: 0 1px 1px rgba(9, 10, 11, 0.05);\n}";
var styles = {"popover":"DateInput-module_popover__26Zs5"};
styleInject(css_248z);

export { styles as default };
